/* ============================================================
   Lovely Colors — Topbar ticker
   - duplicates child set so the marquee loops seamlessly
   - pauses on hover (also via CSS) + when reduced motion is on
   - exposes data-paused for programmatic control
   ============================================================ */
(function () {
  'use strict';

  function init(track) {
    if (track.dataset.tickerInit === 'true') return;
    track.dataset.tickerInit = 'true';

    // Duplicate inner items so the -50% translate loops cleanly
    var html = track.innerHTML;
    track.innerHTML = html + html;

    var bar = track.closest('.lc-topbar');
    if (!bar) return;

    // Respect reduced motion at runtime in case CSS @media isn't picked up
    var mql = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mql && mql.matches) {
      bar.setAttribute('data-paused', 'true');
    }
    if (mql && mql.addEventListener) {
      mql.addEventListener('change', function (e) {
        bar.setAttribute('data-paused', e.matches ? 'true' : 'false');
      });
    }
  }

  function ready() {
    document.querySelectorAll('.lc-topbar-track').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
